export default "__VITE_ASSET__pO$mPVmU__"